"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteMultiSelector = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const useAutocomplete_1 = require("@mui/material/useAutocomplete");
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = __importDefault(require("debounce"));
const autocomplete_selector_styles_1 = require("./autocomplete-selector.styles");
const list_box_component_1 = require("./list-box.component");
const utils_1 = require("../../utils");
const localization_1 = require("../../../localization");
const AutocompleteMultiSelector = ({ options, onChange, selected, placeholder, hasNextPage, groupBy, className, isLoading, moreItemsLoading, noOptionsText, allowCreation, isDisabled, disableClearable, onBlur, onLoadMore, onSearch, getOptionDisabled, renderTags, onSave, onCancel, renderOptionLabel, onClose, onOpen, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const filter = (0, react_1.useMemo)(() => {
        if (onLoadMore) {
            return undefined;
        }
        return (0, useAutocomplete_1.createFilterOptions)();
    }, [onLoadMore]);
    const onSearchChanged = (0, react_1.useMemo)(() => (0, debounce_1.default)((search) => onSearch(search), 250), [onSearch]);
    const handleInputChange = (_e, newValue, reason) => {
        if (reason === 'reset') {
            return;
        }
        setInputValue(newValue);
        if (newValue !== inputValue && onSearch) {
            void onSearchChanged(newValue);
        }
    };
    const handleChange = (_e, options) => {
        onChange(options === null || options === void 0 ? void 0 : options.map(({ value }) => value));
    };
    const onScroll = (0, react_1.useCallback)((event) => {
        if (moreItemsLoading) {
            return;
        }
        const listboxNode = event.currentTarget;
        if (Math.floor(listboxNode.scrollTop + listboxNode.clientHeight) === listboxNode.scrollHeight) {
            void onLoadMore();
        }
    }, [moreItemsLoading, onLoadMore]);
    const renderFilterOptions = (options, params) => {
        const newOptions = onLoadMore ? [...options] : filter(options, params);
        if (!allowCreation) {
            return newOptions;
        }
        const { inputValue } = params;
        const isExisting = options.some((option) => (0, utils_1.areEqualCaseInsensitive)(inputValue, option.label));
        if (inputValue && !isExisting) {
            newOptions.push({
                value: inputValue,
                label: `${String(t({ key: 'CREATE_NEW' }))} '${inputValue}'`,
            });
        }
        return newOptions;
    };
    const derivedInputValue = inputValue || '';
    const selectedOptions = (0, react_1.useMemo)(() => { var _a; return (_a = selected === null || selected === void 0 ? void 0 : selected.map((selectedValue) => ({ label: selectedValue, value: selectedValue }))) !== null && _a !== void 0 ? _a : []; }, [selected]);
    return (react_1.default.createElement(autocomplete_selector_styles_1.StyledMultiSelector, { multiple: true, disableCloseOnSelect: true, disableClearable: disableClearable, disabled: isDisabled, size: 'small', ListboxComponent: list_box_component_1.ListBox, ListboxProps: Object.assign(Object.assign({}, onLoadMore && {
            onScroll: hasNextPage ? onScroll : undefined,
            moreItemsLoading,
            className: (0, classnames_1.default)({ 'list--loading': isLoading }),
        }), (onSave || onCancel) ? { onSave, onCancel } : {}), renderOption: (props, option, { selected }) => {
            if ((option).isDivider) {
                return (react_1.default.createElement("li", Object.assign(Object.assign({}, props), { style: {
                        pointerEvents: 'none',
                        borderBottom: '1px solid #E0E0E0',
                        margin: '4px 0',
                    } })));
            }
            return (react_1.default.createElement("li", Object.assign({}, props), react_1.default.createElement(ui_components_1.Checkbox, { style: { marginRight: 4 }, checked: selected }), renderOptionLabel ? renderOptionLabel(option) : option.label));
        }, renderInput: (params) => (react_1.default.createElement(ui_components_1.TextField, Object.assign({ placeholder: placeholder, variant: 'outlined', background: ui_components_1.baseColors.white }, params))), isOptionEqualToValue: (option, value) => option.value === value.value, popupIcon: null, onChange: handleChange, onInputChange: handleInputChange, inputValue: derivedInputValue, options: options !== null && options !== void 0 ? options : [], value: selectedOptions, groupBy: groupBy, className: className, onBlur: onBlur, loading: isLoading, filterOptions: renderFilterOptions, renderTags: renderTags, noOptionsText: noOptionsText, getOptionDisabled: getOptionDisabled, onClose: onClose, onOpen: onOpen }));
};
exports.AutocompleteMultiSelector = AutocompleteMultiSelector;
exports.default = exports.AutocompleteMultiSelector;
